import { jsx as _jsx } from "react/jsx-runtime";
// catmint/i18n/I18nContext — Internationalization context provider
import { createContext, useState, useCallback, } from "react";
export const I18nContext = createContext(null);
/**
 * Provider for i18n locale state.
 */
export function I18nProvider({ children, config, initialLocale, }) {
    const [locale, setLocaleState] = useState(() => initialLocale ?? config.defaultLocale);
    const setLocale = useCallback((newLocale) => {
        if (!config.locales.includes(newLocale)) {
            throw new Error(`Invalid locale "${newLocale}". Available locales: ${config.locales.join(", ")}`);
        }
        setLocaleState(newLocale);
        // Navigate to locale-prefixed URL
        if (typeof window !== "undefined") {
            const { pathname, search, hash } = window.location;
            // Remove existing locale prefix from pathname
            let cleanPath = pathname;
            for (const loc of config.locales) {
                if (pathname === `/${loc}` || pathname.startsWith(`/${loc}/`)) {
                    cleanPath = pathname.slice(loc.length + 1) || "/";
                    break;
                }
            }
            // Build new URL with locale prefix
            let newPath;
            if (config.strategy === "prefix-except-default" &&
                newLocale === config.defaultLocale) {
                // Default locale doesn't get a prefix
                newPath = cleanPath;
            }
            else {
                newPath = `/${newLocale}${cleanPath === "/" ? "" : cleanPath}`;
            }
            window.history.pushState(null, "", `${newPath}${search}${hash}`);
            window.dispatchEvent(new PopStateEvent("popstate"));
        }
    }, [config]);
    const contextValue = {
        locale,
        locales: config.locales,
        setLocale,
    };
    return (_jsx(I18nContext.Provider, { value: contextValue, children: children }));
}
//# sourceMappingURL=I18nContext.js.map